export const protectedUsers = ['14cac2f1-d573-4faf-8854-995aab6b68e0', 'da82958d-0831-4e10-af53-8c1256f897e4', '0e5acb37-f894-4d7d-9d03-899566e325e7', '33035871-8fcd-421b-9c80-c769e8bcad93', 'd6a33d65-822d-4fbd-b292-3f2a89bd721d']
